export const BRANDS = [
  { slug: "bmw", name: "BMW", aliases: ["bmw"] },
  { slug: "mercedes-benz", name: "Mercedes-Benz", aliases: ["mercedes", "mercedesbenz", "benz"] },
  { slug: "audi", name: "Audi", aliases: ["audi"] },
  { slug: "volkswagen", name: "Volkswagen", aliases: ["volkswagen", "vw"] },
  { slug: "porsche", name: "Porsche", aliases: ["porsche"] },
  { slug: "opel", name: "Opel", aliases: ["opel"] },
  { slug: "ford", name: "Ford", aliases: ["ford"] },
  { slug: "toyota", name: "Toyota", aliases: ["toyota"] },
  { slug: "hyundai", name: "Hyundai", aliases: ["hyundai"] },
  { slug: "kia", name: "Kia", aliases: ["kia"] },
  { slug: "skoda", name: "Škoda", aliases: ["skoda", "škoda"] },
  { slug: "seat", name: "SEAT", aliases: ["seat", "cupra"] },
  { slug: "renault", name: "Renault", aliases: ["renault"] },
  { slug: "peugeot", name: "Peugeot", aliases: ["peugeot"] },
  { slug: "nissan", name: "Nissan", aliases: ["nissan"] },
  { slug: "volvo", name: "Volvo", aliases: ["volvo"] },
  { slug: "mazda", name: "Mazda", aliases: ["mazda"] },
  { slug: "tesla", name: "Tesla", aliases: ["tesla"] },
  { slug: "fiat", name: "Fiat", aliases: ["fiat"] }
];

const EXTRA_LOGOS = new Set(["honda"]);

export function normalizeBrandKey(value) {
  return String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
}

export function brandForVehicle(vehicleBrand) {
  const key = normalizeBrandKey(vehicleBrand);
  return BRANDS.find((brand) => brand.aliases.some((alias) => normalizeBrandKey(alias) === key)) || null;
}

/** Catalogue brands first (in order), then any inventory brand that is not in the list yet. */
export function brandSlugForVehicle(vehicle) {
  const known = brandForVehicle(vehicle.brand);
  return known ? known.slug : normalizeBrandKey(vehicle.brand);
}

export function buildBrandTiles(inventory, contextInventory = inventory) {
  const counts = new Map();
  const extras = [];
  inventory.forEach((vehicle) => {
    const known = brandForVehicle(vehicle.brand);
    const slug = brandSlugForVehicle(vehicle);
    if (!known && !extras.some((extra) => extra.slug === slug)) {
      extras.push({ slug, name: vehicle.brand, aliases: [vehicle.brand], hasLogo: EXTRA_LOGOS.has(slug) });
    }
  });
  contextInventory.forEach((vehicle) => {
    const slug = brandSlugForVehicle(vehicle);
    counts.set(slug, (counts.get(slug) || 0) + 1);
  });
  return [...BRANDS.map((brand) => ({ ...brand, hasLogo: true })), ...extras].map((brand) => ({ ...brand, count: counts.get(brand.slug) || 0, logo: brand.hasLogo ? `/logos/${brand.slug}.svg` : "" }));
}

export function vehicleMatchesBrand(vehicle, brandSlug) {
  if (!brandSlug) return true;
  const known = brandForVehicle(vehicle.brand);
  return (known ? known.slug : normalizeBrandKey(vehicle.brand)) === brandSlug;
}

function normalizeSearchText(value) {
  return String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function vehicleMatchesQuery(vehicle, query) {
  const rawTokens = normalizeSearchText(query).replace(/\b([a-z]{1,3})[\s-]?klasse\b/g, "$1-klasse").split(/\s+/).filter(Boolean);
  if (!rawTokens.length) return true;
  const known = brandForVehicle(vehicle.brand);
  const haystack = normalizeSearchText([vehicle.brand, ...(known ? known.aliases : []), vehicle.title, vehicle.edition, vehicle.category, vehicle.fuel, vehicle.gearbox, vehicle.color, vehicle.year].join(" "));
  const words = haystack.split(/[^a-z0-9.]+/).filter(Boolean);
  const compact = haystack.replace(/[^a-z0-9]/g, "");
  return rawTokens.every((rawToken) => {
    const classMatch = rawToken.match(/^([a-z]{1,3})-?klasse$/);
    if (classMatch) return words.includes(classMatch[1]) && (known ? known.slug === "mercedes-benz" : true);
    const token = rawToken.replace(/[^a-z0-9.]/g, "");
    if (!token) return true;
    if (token.length === 1) return words.includes(token);
    return haystack.includes(token) || compact.includes(token) || words.some((word) => word.startsWith(token));
  });
}
